import { render, staticRenderFns } from "./ModuleButton.vue?vue&type=template&id=92076b1e&scoped=true&"
import script from "./ModuleButton.vue?vue&type=script&lang=js&"
export * from "./ModuleButton.vue?vue&type=script&lang=js&"
import style0 from "./ModuleButton.vue?vue&type=style&index=0&id=92076b1e&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92076b1e",
  null
  
)

export default component.exports